import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { exportGraph, EXPORT_FORMATS } from "./exportGraph";
import FeedbackModal from "./FeedbackModal";
import { isTrialAccess } from "../../helpers/subscription.helpers";

const DownloadMenu = ({
  filename = "export",
  className = "btn bg-green-dark me-3",
  screenLabel,
  feedbackInputs,
  trialWatermark,
}) => {
  const [open, setOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const handleKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open]);

  const handleSelect = async (format) => {
    setOpen(false);
    try {
      await exportGraph(format, filename, { watermark: trialWatermark });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Download failed:", e);
    }
  };

  return (
    <span style={{ display: "inline-block" }}>
      <button
        type="button"
        onClick={() => setFeedbackOpen(true)}
        className={className}
        style={{ marginRight: 8 }}
      >
        Feedback
      </button>
      <FeedbackModal
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
        screenLabel={screenLabel}
        inputs={feedbackInputs}
      />
    <span ref={wrapperRef} style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={className}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        Download <span style={{ fontSize: "0.7em", marginLeft: 4 }}>▾</span>
      </button>
      {open && (
        <div
          role="menu"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: 4,
            background: "white",
            border: "1px solid #e0e0e0",
            borderRadius: 6,
            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
            minWidth: 120,
            zIndex: 1000,
            overflow: "hidden",
          }}
        >
          {EXPORT_FORMATS.map((fmt) => (
            <button
              key={fmt}
              type="button"
              role="menuitem"
              onClick={() => handleSelect(fmt)}
              style={{
                display: "block",
                width: "100%",
                padding: "8px 14px",
                background: "white",
                border: "none",
                textAlign: "left",
                cursor: "pointer",
                fontSize: 14,
                color: "#333",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
            >
              {fmt}
            </button>
          ))}
        </div>
      )}
    </span>
    </span>
  );
};

DownloadMenu.propTypes = {
  filename: PropTypes.string,
  className: PropTypes.string,
  screenLabel: PropTypes.string,
  feedbackInputs: PropTypes.any,
  trialWatermark: PropTypes.bool,
};

DownloadMenu.defaultProps = {
  filename: "export",
  className: "btn bg-green-dark me-3",
  screenLabel: undefined,
  feedbackInputs: undefined,
  trialWatermark: false,
};

const mapStateToProps = (state) => ({
  trialWatermark: isTrialAccess(state.subscription.access),
});

export default connect(mapStateToProps)(DownloadMenu);
